import { useEffect, useState } from "react";
import Card from "antd/es/card/Card";
import { Formik, Form } from "formik";
import * as Yup from "yup";

import { Oval } from "react-loader-spinner";
import axios from "axios";
import toast from "react-hot-toast";

// --------------- component
import { InputField, SelectField } from "../../../components";

// --------------- style
import "./style.css";
import { api } from "../../../api/url";

const genders = [
  { name: "آقا", id: 1 },
  { name: "خانم", id: 2 },
];

const ProfileSchema = Yup.object().shape({
  firstName: Yup.string().required("فیلد نام الزامی می‌باشد"),
  lastName: Yup.string().required("فیلد نام‌خانوادگی الزامی می‌باشد"),
  genderId: Yup.string().required("فیلد جنسیت الزامی می‌باشد"),
  nationalCode: Yup.string()
    .required("فیلد کدملی الزامی می‌باشد")
    .matches(/^(?!\s+$)/, "فیلد نمی‌تواند خالی باشد")
    .matches(/^\d+$/, "فرمت کدملی صحیح نمی‌باشد"),
});

const ProfileDetail = () => {
  const [data, setData] = useState();
  // ------------------- get user info
  const GetProfile = async () => {
    await axios({
      method: "get",
      url: api + "appointment/user/getbyid/" + localStorage.getItem("user"),
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    GetProfile();
  }, []);

  // ------------------- update user info
  const UpdateUser = async (value, setSubmitting) => {
    await axios({
      method: "put",
      url: api + "appointment/user/update",
      data: {
        userId: localStorage.getItem("user"),
        firstName: value.firstName,
        lastName: value.lastName,
        genderId: value.genderId,
        nationalCode: value.nationalCode,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        setSubmitting(false);

        if (res.data.successfull === false)
          res.data.validationErrors.map((item) => toast.error(item));
        else toast.success("ویرایش اطلاعات با موفقیت انجام شد!");
      })
      .catch((err) => {
        toast.success("خطا در ویرایش اطلاعات");
        setSubmitting(false);
      });
  };
  if (data)
    return (
      <Card>
        <Formik
          initialValues={{
            firstName: data.firstName,
            lastName: data.lastName,
            genderId: data.genderId,
            nationalCode: data.nationalCode,
            mobileNo: data.mobileNo,
          }}
          validationSchema={ProfileSchema}
          enableReinitialize
          onSubmit={(values, { setSubmitting }) => {
            UpdateUser(values, setSubmitting);
          }}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="profile-field-section">
                <InputField name="firstName" title="نام" />
                <InputField name="lastName" title="نام‌خانوادگی" />
              </div>

              <div className="profile-field-section">
                <InputField inputstyle={{ textAlign: 'right' }} type='tel' maxlength="10" name="nationalCode" title="کدملی" />
                <SelectField options={genders} name="genderId" title="جنسیت" />
              </div>
              <div className="profile-field-section profile-single-field">
                <InputField disabled name="mobileNo" title="شماره تماس" />
              </div>

              <button
                className="submit-form-btn"
                type="submit"
                disabled={isSubmitting}
              >
                تایید
              </button>
            </Form>
          )}
        </Formik>
      </Card>
    );
  else
    return (
      <Card>
        <div className="loading-container">
          <Oval
            visible={true}
            height="35"
            width="35"
            strokeWidth={3}
            color="#1E2B3B"
            ariaLabel="oval-loading"
            secondaryColor="#ACADAD"
            wrapperStyle={{}}
            wrapperClass=""
          />
        </div>
      </Card>
    );
};

export default ProfileDetail;
